// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    EnrollmentIsValidMemberNumberModelResponse,
    EnrollmentIsValidMemberNumberRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EnrollmentV1Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Method to check a MemberNumber is valid?
     * @param enrollmentIsValidMemberNumberRequestModel Input Request Criteria
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async memberNumberValidationByTenantIdProgramId (enrollmentIsValidMemberNumberRequestModel: EnrollmentIsValidMemberNumberRequestModel, xProgramId?: number): Promise<AxiosResponse<EnrollmentIsValidMemberNumberModelResponse>> {
        const _url_ = '/enrollment/v1/MemberNumberValidation';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enrollmentIsValidMemberNumberRequestModel' is not null or undefined
        if (enrollmentIsValidMemberNumberRequestModel === null || enrollmentIsValidMemberNumberRequestModel === undefined) {
            throw new Error('Required parameter enrollmentIsValidMemberNumberRequestModel was null or undefined when calling memberNumberValidationByTenantIdProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentIsValidMemberNumberRequestModel, "EnrollmentIsValidMemberNumberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentIsValidMemberNumberModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentIsValidMemberNumberModelResponse");
        }
        return response;
    }
}
